import React, { useState, useEffect } from 'react';
import { Input, Label } from '../../Shared';
import { useAppContext } from '../../context/AppContext';
import axios from 'axios';
import States from '../../components/States';

const PermitForm = ({company, onClose, permit,setPermit,reset,setReset,editPermitItemId, load}) => {
  const {  axiUrl } = useAppContext();


  const bmeus = [
    {
      name: "Business Mail Entry - United States Postal Service",
      address: "5433 W Sligh Ave Ste A",
      city: "Tampa",
      state: "FL",
      zIP: "33634-9651",
      telephone: "1-877-672-0007",
      serves: "33702"
    },
    {
      name: "Business Mail Entry - United States Postal Service",
      address: "5433 W Sligh Ave Ste B",
      city: "Tampa",
      state: "FL",
      zIP: "33634-9653",
      telephone: "1-877-672-0007",
      serves: "33702"
    },
    {
      name: "Business Mail Entry - United States Postal Service",
      address: "2000 E Landstreet",
      city: "Orlando",
      state: "FL",
      zIP: "32824-7975",
      telephone: "1-877-672-0007",
      serves: "34762"
    },
    {
      name: "Business Mail Entry - United States Postal Service",
      address: "850 Tallevast Rd",
      city: "Sarasota",
      state: "FL",
      zIP: "34260-5000",
      telephone: "1-877-672-0007",
      serves: "34762"
    },
    {
      name: "Business Mail Entry - United States Postal Service",
      address: "3135 1st Ave N",
      city: "St Petersburg",
      state: "FL",
      zIP: "33730-9998",
      telephone: "1-877-672-0007",
      serves: "34762"
    },
    {
      name: "Business Mail Entry - United States Postal Service",
      address: "800 Rinehart Rd",
      city: "Mid Florida",
      state: "FL",
      zIP: "32799-8804",
      telephone: "1-877-672-0007",
      serves: "44444"
    }
  ];

  
  const [formData, setFormData] = useState({
    permitName: '',
    companyName: '',
    address1: '',
    address2: '',
    city: '',
    state: 'FL',
    zip: '',
    isDefault: false,
    permitType: 'Indicia',
    permitNumber: '',
    dueNetNumber: '',
    accountNumber: '',
    bmeu: '',
    company: company
  });
  const [filteredBmeus, setFilteredBmeus] = useState(bmeus);

  useEffect(() => {
    if (permit) {
      
      setFormData({
        permitName: permit.permitName || '',
        companyName: permit.companyName || '',
        address: permit.address || '',
        address2: permit.address2 || '',
        city: permit.city || '',
        state: permit.state || '',
        zip: permit.zip || '',
        isDefault: permit.isDefault || false,
        permitType: permit.permitType || 'Stamp',
        permitNumber: permit.permitNumber || '',
        dueNetNumber: permit.dueNetNumber || '',
        accountNumber: permit.accountNumber || '',
        bmeu: permit.bmeu || '',
        company: company
      });
    }
  }, [permit]);

  useEffect(() => {
    let filtered = bmeus;

    // Filter by BMEU input (city or ZIP)
    if (formData.bmeu) {
      const searchLower = formData.bmeu.toLowerCase();
      filtered = bmeus.filter(bmeu =>
        bmeu.city.toLowerCase().includes(searchLower) ||
        bmeu.zIP.toLowerCase().includes(searchLower) ||
        `${bmeu.name}, ${bmeu.address}, ${bmeu.city}, ${bmeu.state} ${bmeu.zIP}`.toLowerCase().includes(searchLower)
      );
    }

    // Sort by ZIP code match if formData.zip is provided
    if (formData.zip) {
      const zipPrefix = formData.zip.slice(0, 5); // Use first 5 digits of ZIP
      const matchingBmeus = filtered.filter(bmeu => bmeu.serves === zipPrefix);
      const nonMatchingBmeus = filtered.filter(bmeu => bmeu.serves !== zipPrefix);
      filtered = [...matchingBmeus, ...nonMatchingBmeus];
    }

    setFilteredBmeus(filtered);
  }, [formData.zip, formData.bmeu]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
   
        const url = editPermitItemId ? `${axiUrl}/permits/updatepermitholders` : `${axiUrl}/permits/addpermitholder`;
        const payload = editPermitItemId ? { ...formData, id: editPermitItemId } : formData;
console.log('paylod',payload)
   const res = await axios.post(url, payload)
      .then(res => {console.log(res.data)
         setPermit(null) 
       setReset(!reset);
    onClose();
  })
       
  };

  return (
    <div className='w-full'>
      <form onSubmit={handleSubmit}>
        <div className='flex w-full gap-[20px]'>
          <div className='flex-3 relative'>
            <div className='w-full'>
              <Label>Permit Name</Label>
            </div>
            <div>
              <Input 
                type="text" 
                name="permitName"
                value={formData.permitName}
                onChange={handleChange}
                required
              />
            </div>
            <div className='relative p-3 border border-gray-400 mt-3 pb-6'>
              <h2 className="absolute -top-[13px] bg-white px-[3px]">Permit Owner Information</h2>
              <div className='mb-[6px]'>
                <Label fontSize="12px" mb="2px">Company Name</Label>
                <Input 
                  width="100%" 
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className='mb-[6px]'>
                <Label fontSize="12px" mb="2px">Address 1</Label>
                <Input 
                  width="100%" 
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className='mb-[6px]'>
                <Label fontSize="12px" mb="2px">Address 2</Label>
                <Input 
                  width="100%" 
                  name="address2"
                  value={formData.address2}
                  onChange={handleChange}
                />
              </div>
              <div className='flex gap-[5px]'>
                <div className='mb-[6px] flex-2 gap-[5px]'>
                  <Label fontSize="12px" mb="2px">City</Label>
                  <Input 
                    width="100%" 
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className='mb-[6px] flex-2'>
                  <Label fontSize="12px" mb="2px">State</Label>

                  <States setFormData={setFormData} formData={formData} />
             
                </div>
                <div className='mb-[6px] flex-1'>
                  <Label fontSize="12px" mb="2px">Zip</Label>
                  <Input 
                    width="100%" 
                    name="zip"
                    value={formData.zip}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='flex-1 pt-[20px] items-center min-w-[140px] px-[8px]'>
            <div className='pl-[12px]'>
              <label className="inline-flex items-center mt-2">
                <input 
                  type="checkbox" 
                  className="mr-2" 
                  name="isDefault"
                  checked={formData.isDefault}
                  onChange={handleChange}
                />
                <span className="text-sm text-gray-700 text-[12px]">Default Permit</span>
              </label>
            </div>
            <div className='relative p-3 border border-gray-400 mt-6 pb-6'>
              <h2 className="absolute -top-[13px] bg-white px-[3px]">Permit Type</h2>
             
                       <div className='pl-[12px]'>
                <label className="inline-flex items-center mt-2">
                  <input 
                    type="radio" 
                    className="mr-2" 
                    name="permitType" 
                    value="Indicia"
                    checked={formData.permitType === 'Indicia'}
                    onChange={handleChange}
                  />
                  <span className="text-sm text-gray-700">Indicia</span>
                </label>
              </div> <div className='pl-[12px]'>
                <label className="inline-flex items-center mt-2">
                  <input 
                    type="radio" 
                    className="mr-2" 
                    name="permitType" 
                    value="Stamp"
                    checked={formData.permitType === 'Stamp'}
                    onChange={handleChange}
                  />
                  <span className="text-sm text-gray-700">Stamp</span>
                </label>
              </div>
    
              <div className='pl-[12px]'>
                <label className="inline-flex items-center mt-2">
                  <input 
                    type="radio" 
                    className="mr-2" 
                    name="permitType" 
                    value="Meter"
                    checked={formData.permitType === 'Meter'}
                    onChange={handleChange}
                  />
                  <span className="text-sm text-gray-700">Meter</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className='relative p-3 border border-gray-400 pb-6'>
            <h2 className="absolute -top-[13px] bg-white px-[3px]">Permit Information</h2>
            <div className='flex gap-[10px]'>
              <div className='mb-[6px] mt-[18px] max-w-[150px]'>
                <Label fontSize="12px" mb="2px">Permit Number</Label>
                <Input 
                  width="100%" 
                  name="permitNumber"
                  value={formData.permitNumber}
                  onChange={handleChange}
                  maxLength="10"
                  pattern="[0-9\s]*"
                  required
                />
              </div>
              <div className='relative mb-[6px]'>
                <Label fontSize="12px" mb="2px" width="100%">
                  Net Due Permit Number<br />
                  <span className='w-full relative text-[12px] -mt-4'>(For Stamps Only)</span>
                </Label>
                <Input 
                  width="100%" 
                  name="dueNetNumber"
                  value={formData.dueNetNumber}
                  onChange={handleChange}
                  required={formData.permitType === 'Stamp'}
                />
              </div>
              <div className='mb-[6px] mt-[18px]'>
                <Label fontSize="12px" mb="2px">Account Number (EPS or Other)</Label>
                <Input 
                  width="100%" 
                  name="accountNumber"
                  value={formData.accountNumber}
                  onChange={handleChange}
                  
                />
              </div>
            </div>
            <div className='mt-[10px] mb-[6px] boder-1
            '>
              <Label fontSize="12px" mb="2px">BMEU where permit is registered</Label>
              <Input
                type="text"
                name="bmeu"
                value={formData.bmeu}
                onChange={handleChange}
                list="bmeu-options"
                placeholder="Type city or ZIP to filter BMEUs"
                className="w-full max-w-[600px] p-2 border border-gray-400 rounded-md"
                required
              />
              <datalist id="bmeu-options">
                {filteredBmeus.map((bmeu, index) => (
                  <option
                    key={index}
                    value={`${bmeu.address}, ${bmeu.city}, ${bmeu.state} ${bmeu.zIP}`}
                  />
                ))}
              </datalist>
            </div>
          </div>
        </div>
        <div className="flex justify-end space-x-2 mt-[10px]">
          <button
            type="button"
            onClick={onClose}
            className="text-[12px] px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="text-[12px] px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
          >
            {permit ? 'Update Permit' : 'Add Permit'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default PermitForm;

